module.exports = __webpack_public_path__ + "img/antes_despues_37.2f606a2d.png";